<p class="mb-2">
    <img src="assets/img/ic_help.svg" /> Contact Details
    <span>
        <button type="button" class="bg-main2 btn-add-1">
            <i (click)="addContact('#zero_add_contact','Add Personal Contact')" class="fa fa-plus"></i>
        </button>
    </span>
</p>
<div class="bg-white p-3 shadow-main border-up-down">
    <table class="font-weight-normal w-100">
        <tr *ngFor="let dat of myContact">
            <td>
                <a class="name">
                    <b>{{dat.cont_person_name}}</b>
                    <div class="edit-icon" *ngIf="dat.is_secondary == 1">
                        <i (click)="editContact(dat.cont_id,'Edit Personal Contact')" class="fa fa-pencil"></i>
                    </div>
                </a>
                <br> {{dat.cont_1}}, {{dat.cont_2}}
                <br> {{dat.email_1}}, {{dat.email_2}}
                <br>
                <span *ngIf="dat.is_primary == 1" class="btn-info btnspandark">Official</span>
                <span *ngIf="dat.is_secondary == 1" class="btn-warning text-white btnspandark">Personal</span>
            </td>
        </tr>
    </table>
</div>
<!-- <div class="flex-fill add-mrf-card">
  <div class="card-padding-bottom">
      <h3 class="card-title page-header0"><i class="fa fa-address-book"></i> Contact Details
          <div class="edit-icon"><i (click)="addContact('#zero_add_contact','Add Personal Contact')" class="fa fa-plus"></i></div>
      </h3>-->
      <!-- *ngIf="config.add" -->
      <!-- <hr>
      <div class="experience-box add-p-b10 card-h">
          <ul class="experience-list">
              <li *ngFor="let dat of myContact">
                  <div class="experience-user">
                      <div class="before-circle"></div>
                  </div>
                  <div class="experience-content">
                      <div class="timeline-content"> -->


                          <!-- contact view -->
                          <!-- <a class="name">{{dat.cont_person_name}}
                              <div class="edit-icon" *ngIf="dat.is_secondary == 1">
                                  <i (click)="editContact(dat.cont_id,'Edit Personal Contact')" class="fa fa-pencil"></i>
                              </div>
                          </a>
                          <div>{{dat.cont_1}}, {{dat.cont_2}}</div>
                          <div>{{dat.email_1}}, {{dat.email_2}}</div>
                          <div>
                              <span *ngIf="dat.is_primary == 1" class="badge badge-primary">Official</span>
                              <span *ngIf="dat.is_secondary == 1" class="badge badge-warning">Personal</span>
                          </div> -->
                          <!--end contact view  -->
                      <!--</div>
                  </div>
              </li>
          </ul>
      </div> -->
      <!-- <table class="table table-custom title">
          <tr *ngFor="let dat of myContact">
              <td>Contact Person</td>
              <td>{{dat.cont_person_name}}</td>
          </tr>
          <tr>
              <h4><i class="fa fa-phone"></i> Primary Contact</h4>
          </tr>
          <tr *ngFor="let dat of myContact">
              <td>Contact Number</td>
              <td>{{dat.cont_1}}</td>
          </tr>
          <tr *ngFor="let dat of myContact">
              <td>Email Id</td>
              <td>{{dat.email_1}}</td>
          </tr>
          <tr>
              <h4><i class="fa fa-phone"></i> Secondary Contact</h4>
          </tr>
          <tr *ngFor="let dat of myContact">
              <td>Contact Number</td>
              <td>{{dat.cont_2}}</td>
          </tr>
          <tr *ngFor="let dat of myContact">
              <td>Email Id</td>
              <td>{{dat.email_2}}</td>
          </tr>
      </table> -->
      <!-- <div class="experience-box add-p-b10 card-h">
          <ul class="experience-list">
              <li *ngFor="let dat of myContact">
                  <div class="experience-user">
                      <div class="before-circle"></div>
                  </div>
                  <div class="experience-content">
                      <div class="timeline-content">
                          <a class="name">{{dat.cont_person_name}}
                            <div class="edit-icon" *ngIf="config.delete">
                                <i (click)="deleteContact(dat.cont_id)" class="fa fa-trash-o"></i>
                            </div>
                            <div class="edit-icon" >
                                <i (click)="editContact(dat.cont_id,'Edit Contact')" class="fa fa-pencil"></i>
                            </div>
                          </a>
                          <div>{{dat.cont_1}} {{dat.cont_2}} </div>
                          <div>{{dat.cont_2}}</div>
                          <div> {{dat.ct_name}}</div>
                          <div>{{dat.email_1}} {{dat.email_2}}</div>
                          <span class="time"> <b>{{dat.fax}}</b></span>
                      </div>
                  </div>
              </li>
          </ul>
      </div> -->
  <!-- </div>
</div> -->



<div id="zero_add_contact" class="modal  custom-modal fade" data-backdrop="static" role="dialog">
  <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="zero_country_form_title"> {{dynamicHeader}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
          </div>

          <form [formGroup]="contactForm" (ngSubmit)="onSubmitContact()" id="zero_country_form" class="horizontal-form" name="zero_country_form" method="post" enctype="multipart/form-data">
              <div class="modal-body">
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="country_name">Person Name<span class="text-danger">*</span></label>
                              <input class="form-control" id="country_name" type="text" formControlName="cont_person_name">
                              <div *ngIf="subAdd && addErrorMsg.cont_person_name.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.cont_person_name.errors.required">Person Name is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="iso_code">Contact<span class="text-danger">*</span></label>
                              <input class="form-control" id="country_name" type="number" formControlName="contact_1">
                              <div *ngIf="subAdd && addErrorMsg.contact_1.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.contact_1.errors.required">Contact is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="iso_code">Contact II</label>
                              <input class="form-control" id="country_name" type="number" formControlName="contact_2">
                              <div *ngIf="subAdd && addErrorMsg.contact_2.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.contact_2.errors.required">Contact II is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="lang">Contact III</label>
                              <input class="form-control" id="country_name" type="number" formControlName="contact_3">
                              <div *ngIf="subAdd && addErrorMsg.contact_3.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.contact_3.errors.required">Contact III is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Fax</label>
                              <input class="form-control" id="country_name" type="text" formControlName="fax">
                              <div *ngIf="subAdd && addErrorMsg.fax.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.fax.errors.required">Fax is required !</div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="lang">Email-Id</label>
                              <input class="form-control" id="country_name" type="text" formControlName="email_1">
                              <div *ngIf="subAdd && addErrorMsg.email_1.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.email_1.errors.required">Email id is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label for="curr">Email-Id II </label>
                              <input class="form-control" type="text" formControlName="email_2">
                              <div *ngIf="subAdd && addErrorMsg.email_2.errors" class="form-error">
                                  <div *ngIf="addErrorMsg.email_2.errors.required">Email id II is required !</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                  <button type="button" class="btn btn-danger btn-sm" (click)="onResetContact()" data-dismiss="modal">Close</button>
              </div>
          </form>
      </div>
  </div>
</div>
